module.exports = __webpack_public_path__ + "static/media/about_black_ginssen_icon5.2f1746cc.png";